import React from 'react';
import { Save, Loader2 } from 'lucide-react';

const SaveButton = ({ isSaving, translations }) => {
  return (
    <div className="flex justify-end">
      <button
        type="submit"
        disabled={isSaving}
        className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-lg shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isSaving ? (
          <>
            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
            {translations("profile.saving")}  

          </>
        ) : (
          <>
            <Save className="w-4 h-4 mr-2" />
            {translations("profile.save")}  

          </>
        )}
      </button>
    </div>
  );
};

export default SaveButton;